import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App from "./app";
import styles from "./assets/stylesheets/embed.css?url";
import { MemoryRouter } from "react-router";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      // This key needs to exactly match the configuration in vite.config.js
      filterKeys: ["tree-bankforum-discussit"],
      behaviour: "drop-error-if-exclusively-contains-third-party-frames",
    }),
  ],
});

class BankforumDiscussitElement extends HTMLElement {
  // Static methods
  static tagName = "bankforum-discussit";

  static register(tagName = this.tagName, registry) {
    if ("customElements" in window) {
      (registry || customElements).define(tagName, this);
    }
  }

  // Instance methods
  connectedCallback() {
    window.addEventListener("resize", this.setElementHeight.bind(this));
    window.addEventListener("blur", this.setElementHeight.bind(this));
    this.setElementHeight();
    this.shadow = this.attachShadow({ mode: "closed" });
    this.renderElement();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.setElementHeight.bind(this));
    window.removeEventListener("blur", this.setElementHeight.bind(this));
  }

  renderElement() {
    ReactDOM.createRoot(this.shadow).render(
      <MemoryRouter>
        <link rel="stylesheet" href={this.stylesheetURL} />
        <script
          type="module"
          src="https://tree-projects.s3.eu-central-1.amazonaws.com/tellit/embed.js"
        ></script>
        <App locale={this.locale} root={this} />
      </MemoryRouter>,
    );
  }

  setElementHeight() {
    this.style.setProperty("--app-height", `${window.innerHeight}px`);
  }

  get stylesheetURL() {
    return styles;
  }

  get locale() {
    return this.lang || document.documentElement.lang;
  }
}

BankforumDiscussitElement.register();
